import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyC0Zg5BsDrsQYjJ2cvTTdecwF_rukheQfA",
  authDomain: "feirateste-279c6.firebaseapp.com",
  databaseURL: "https://feirateste-279c6-default-rtdb.firebaseio.com",
  projectId: "feirateste-279c6",
  storageBucket: "feirateste-279c6.firebasestorage.app",
  messagingSenderId: "401580035438",
  appId: "1:401580035438:web:fc52c5499691429ee2857f",
  measurementId: "G-BDPM8WWBC4"
};

const app = initializeApp(firebaseConfig);

export { app };
export const auth = getAuth(app); 
export const db = getFirestore(app);
